export default __webpack_public_path__ + "static/media/ghana.ac0abec4.png";